import React from 'react';

const SentimentControls = ({ labelType, sentimentStates, handleSentimentChange }) => {
  return (
    <div className="sentiment-controls">
      <p>Filter sentiment for {labelType}:</p>

      <label>
        <input
          type="checkbox"
          checked={sentimentStates.positive}
          onChange={() => handleSentimentChange("positive")}
        />
        Positive
      </label>

      <label>
        <input
          type="checkbox"
          checked={sentimentStates.negative}
          onChange={() => handleSentimentChange("negative")}
        />
        Negative
      </label>

      <label>
        <input
          type="checkbox"
          checked={sentimentStates.mixed}
          onChange={() => handleSentimentChange("mixed")}
        />
        Mixed
      </label>
    </div>
  );
}

export default SentimentControls;
